<template>
    <div id="step-motivation" class="step">
        <div class="col-12">
            <div :class="['radio-check', picked === motivation.value ? 'active' : '']" v-for="motivation in motivations"
                 v-on:click="setMotivation(motivation.value)">
                <div id="flat" class="image">
                    <img :src="assetsUrl + '/motivation/' + motivation.value + '.svg'">
                </div>
                <div class="text">
                    {{ motivation.text }}
                </div>
                <input type="radio" name="motivation" required :value="motivation.value" v-model="picked">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Motivation",

        props: ['assetsUrl'],

        data: function() {
            return {
                picked: null,
                motivations: [
                    { value: 2, text: 'Prodávám' },
                    { value: 1, text: 'Kupuji' },
                    { value: 3, text: 'Vlastním' },
                    { value: 5, text: 'Jiné' },
                ],
            }
        },

        computed: {
            type: function () {
                let type = this.$parent.getType();
                if (type == "cottage") {
                    type = "house";
                }

                return type;
            },

            required: function () {
                console.log(this.picked);
                return this.picked != null;
            }
        },

        methods: {
            setMotivation: function (motivation) {
                this.picked = motivation;
            },
        }
    }
</script>

<style scoped>
    .radio-check {
        width: 24%;
        text-align: center;
        cursor: pointer;
    }

    .radio-check .text {
        display: block;
        padding-top: 10px;
    }

    input[type="radio"] {
        display: none;
    }

    @media (max-width: 767px) {
        .radio-check {
            width: 100%;
        }
    }
</style>